import { BellOutlined } from '@ant-design/icons';
import { Badge, Button, notification, Popover, Typography } from 'antd';
import { notificationsAPI } from 'api/notifications';
import { NotificationList } from 'components/list/notification-list';
import { onReceiveMessage } from 'config/firebase';
import { memo, useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useAppSelector } from 'store';
import { selectUserProfile } from 'store/user/user.slice';
import { QUERY_KEY } from 'utils/query-key.enum';

import { MessagePayload } from 'firebase/messaging';

const UserNotification = () => {
  const userProfile = useAppSelector(selectUserProfile);
  const [showNotification, setShowNotification] = useState(false);

  const { data: notifyCount, refetch: refetchNotifyCount } = useQuery(
    [QUERY_KEY.GET_NOTIFICATION_COUNT],
    () => notificationsAPI.count(),
    { enabled: !!userProfile },
  );
  const { mutate: readAll, isLoading: isLoadingReadAll } = useMutation({
    mutationFn: notificationsAPI.readAll,
    onSuccess: () => {
      refetchNotifyCount();
    },
  });

  const { mutate } = useMutation({
    mutationFn: notificationsAPI.update,
    onSuccess: () => {
      refetchNotifyCount();
    },
  });

  const onClickHandler = (id: number) => {
    mutate({ id });
  };

  useEffect(() => {
    try {
      if (!userProfile) return;

      onReceiveMessage((payload: MessagePayload) => {
        notification.info({
          message: payload.notification?.title,
          description: payload.notification?.body,
        });
      });
    } catch (error) {
      console.error(error);
    }
  }, [userProfile]);

  return (
    <Popover
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography.Title level={3} style={{ marginTop: 0 }}>
            Thông báo
          </Typography.Title>
          <Button
            type="text"
            loading={isLoadingReadAll}
            onClick={() => readAll()}
          >
            Đọc tất cả
          </Button>
        </div>
      }
      content={
        <NotificationList
          setShowNotification={setShowNotification}
          onClickItem={onClickHandler}
        />
      }
      overlayStyle={{ width: 380, maxHeight: '80vh', overflow: 'auto' }}
      trigger="click"
      open={showNotification}
      onOpenChange={setShowNotification}
      placement="bottom"
      style={{ width: 360 }}
    >
      <Badge count={notifyCount?.count ?? 0}>
        <Button shape="circle" type="text" icon={<BellOutlined />} />
      </Badge>
    </Popover>
  );
};

export default memo(UserNotification);
